import React from 'react';
import Reveal from '../components/Reveal';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-transparent text-on-surface">
      <div className="max-w-container-max mx-auto">
        <Reveal>
          <div className="mb-16">
            <h1 className="font-display-lg text-display-lg text-on-surface mb-6">
              DISCLAIMER
            </h1>
            <div className="w-12 h-px bg-secondary mb-8"></div>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="glass-panel p-8 md:p-12 prose prose-invert max-w-none">
            <p className="text-on-surface-variant mb-6">
              The information provided on the HBB0011 Realty website is for general informational purposes only. All information on the site is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.
            </p>
            
            <p className="text-on-surface-variant mb-6">
              Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site is solely at your own risk.
            </p>

            <p className="text-on-surface-variant mb-6">
              The site may contain links to other websites or content belonging to or originating from third parties. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us.
            </p>

            <p className="text-on-surface-variant mb-6">
              The architectural representations, specifications, designs, and dimensions provided on this website are conceptual and subject to change without prior notice. They do not constitute an offer, an invitation to offer, or part of a contract.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default Disclaimer;
